import React, { Component } from 'react';
import  './Header.css';
import vid from '../img/hdbgvd.mp4';

class Header extends Component {
  render() {
    return (
      <div id="home">
          <header className="masthead">
        
        <div className="intro-text">
            <div className="intro-lead-in">My work as a Front-End developer</div>
            <div className="intro-heading text-uppercase">MY PORTFOLIO</div>
            <a className="btn btnhov" href="#resume">Know me more</a>
        </div>
        <video autoPlay loop muted className="vid">
        <source src={vid} type="video/mp4"></source>
        </video>
        <div className="opac"></div>
       
  </header>
      </div>
    );
  }
}

export default Header;
